(() => {
  const button = document.querySelector('[data-ambience]');
  if (!button) return;
  let context, master, sources = [], enabled = false;
  function createSound() {
    context = new (window.AudioContext || window.webkitAudioContext)();
    master = context.createGain();
    master.gain.value = 0;
    master.connect(context.destination);
    const buffer = context.createBuffer(1, context.sampleRate * 8, context.sampleRate);
    const samples = buffer.getChannelData(0);
    let brown = 0;
    for (let i = 0; i < samples.length; i++) {
      brown = (brown + (Math.random() * 2 - 1) * .02) / 1.02;
      samples[i] = brown * 2.8;
    }
    const wind = context.createBufferSource();
    wind.buffer = buffer; wind.loop = true;
    const filter = context.createBiquadFilter();
    filter.type = 'lowpass'; filter.frequency.value = 520;
    const windGain = context.createGain(); windGain.gain.value = .025;
    wind.connect(filter).connect(windGain).connect(master); wind.start(); sources.push(wind);
    [110, 164.81, 220.35].forEach((frequency,index) => {
      const oscillator = context.createOscillator();
      oscillator.type = 'sine'; oscillator.frequency.value = frequency;
      const gain = context.createGain(); gain.gain.value = .035 / (index + 1);
      oscillator.connect(gain).connect(master); oscillator.start(); sources.push(oscillator);
      const pulse = context.createOscillator(); pulse.frequency.value = .08 + index * .03;
      const depth = context.createGain(); depth.gain.value = .009;
      pulse.connect(depth).connect(gain.gain); pulse.start(); sources.push(pulse);
    });
  }
  let melodyTimer, step = 0;
  function tone(frequency, duration, volume, end = frequency) {
    const now = context.currentTime, osc = context.createOscillator(), gain = context.createGain();
    osc.frequency.setValueAtTime(frequency, now); osc.frequency.exponentialRampToValueAtTime(end, now + duration);
    gain.gain.setValueAtTime(0, now); gain.gain.linearRampToValueAtTime(volume, now + .04);
    gain.gain.exponentialRampToValueAtTime(.0001, now + duration);
    osc.connect(gain).connect(master); osc.start(); osc.stop(now + duration + .05);
    osc.onended = () => { osc.disconnect(); gain.disconnect(); };
  }
  function phrase() {
    if (!enabled || context.state !== 'running') return;
    const notes = [523.25, 622.25, 493.88, 369.99, 523.25, 0, 349.23, 0];
    const note = notes[step % notes.length];
    if (note) { tone(note, 2.4, .19); tone(note * 2.008, 1.1, .045); }
    if (step % 4 === 0) { tone(62, 1.7, .25, 39); tone(310, 3.5, .085, 145); }
    if (step % 8 === 6) tone(780, 2.8, .055, 240);
    step++;
  }
  async function setSound(next) {
    clearInterval(melodyTimer);
    try {
      if (next && !context) createSound();
      if (next) await context.resume();
      enabled = next;
      if (next) { phrase(); melodyTimer = setInterval(phrase, 1350); }
      if (context) { master.gain.cancelScheduledValues(context.currentTime); master.gain.setTargetAtTime(next ? .42 : 0,context.currentTime,.3); }
      button.setAttribute('aria-pressed', String(enabled));
      button.querySelector('[data-ambience-label]').textContent = enabled ? button.dataset.on : button.dataset.off;
    } catch {
      enabled = false;
      button.setAttribute('aria-pressed','false');
      button.querySelector('[data-ambience-label]').textContent = button.dataset.off;
    }
  }
  button.addEventListener('click', () => setSound(!enabled));
  window.addEventListener('vice:cart-surprise', () => {
    if (!enabled || !context || context.state !== 'running') return;
    const now = context.currentTime;
    const sting = context.createOscillator();
    const gain = context.createGain();
    sting.type = 'triangle';
    sting.frequency.setValueAtTime(260,now);
    sting.frequency.exponentialRampToValueAtTime(55,now+.5);
    gain.gain.setValueAtTime(0,now);
    gain.gain.linearRampToValueAtTime(.14,now+.025);
    gain.gain.exponentialRampToValueAtTime(.001,now+.6);
    sting.connect(gain).connect(master); sting.start(); sting.stop(now+.65);
  });
  document.addEventListener('visibilitychange', () => {
    if (!context) return;
    if (document.hidden) context.suspend();
    else if (enabled) context.resume().catch(() => setSound(false));
  });
  window.addEventListener('pagehide', () => context?.suspend());
})();
